















import { Component, Vue, Provide, Watch, Inject } from "vue-property-decorator";
import { Route } from "vue-router";
import { Badge, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

Vue.use(Badge)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem);

@Component({
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next((vm: any) => {
      let path = to.path;
      if (path[0] === "/") {
        path = path.substr(1);
      }
      if (vm.activedMenuPath !== path) {
        vm.activedMenuPath = path;
      }
      if (to.matched && to.matched.length === 3) {
        vm.activedMenuPath = to.matched[1].path.replace("/", "");
      }
    });
  },
  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    let path = to.path;
    if (path[0] === "/") {
      path = path.substr(1);
    }
    const vm = this as any;
    if (vm.activedMenuPath !== path) {
      vm.activedMenuPath = path;
    }
    if (to.matched && to.matched.length === 3) {
      vm.activedMenuPath = to.matched[1].path.replace("/", "");
    }
    next();
  }
})

export default class Home extends Vue {
  searchValue = "";
  activedMenuPath = "monitor";

  @Inject()
  getTitle!: Function;

  get userEntity() {
    return this.$store.getters["user/user"] || {};
  }

  get userName() {
    return this.userEntity.name;
  }

  get menus() {
    const user = this.userEntity;
    return this.$store.getters["menu/menus"](user.level);
  }

  logout() {
    this.$store.dispatch("user/logout").then(() => {
      window.location.href = "/";
    });
  }

  mounted() {
    const project = this.$store.state.project.info;
    if (project) {
      document.title = `专利专题数据库-${project.name}`;
    }
  }

  @Provide()
  isSuperUser() {
    const level = (this.$store.getters["user/user"] || {}).level;
    return level === "ADMIN";
  }

  created() {
    const taskId = window.localStorage.getItem(`patentsync-taskid-${this.userEntity.id}`);
    if (!isEmptyOrWhiteSpace(taskId)) {
      this.$store.commit("patentsync/taskId", taskId);
    }
  }

  @Watch("$store.state.patentsync.taskId")
  startPatentSync() {
    if (isEmptyOrWhiteSpace(this.$store.state.patentsync.taskId)) {
      return;
    }
    return this.$store.dispatch("patentsync/queryProgress");
  }
}
